var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleJobIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 130,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.875 320h-23.75l-12.407 92.636 24.282 30.352 24.282-30.352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.707 290h24.586l5-30h-34.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.133 415.009 14.701-109.766-7.541-45.243h-27.293c-66.274 0-120 53.726-120 120v87c0 8.284 6.716 15 15 15h172.791l-44.504-55.63c-2.558-3.197-3.698-7.302-3.154-11.361z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.561 263.201c-8.85-2.084-18.074-3.201-27.561-3.201h-27.293l-7.54 45.243 14.701 109.766c.544 4.059-.596 8.164-3.154 11.362l-44.505 55.629h77.832c-9.438-12.544-15.041-28.129-15.041-45v-112c0-25.614 12.911-48.263 32.561-61.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 280h-8.5v-25c0-19.299-15.701-35-35-35h-40c-19.299 0-35 15.701-35 35v25h-8.5c-24.853 0-45 20.147-45 45v10h217v-10c0-24.853-20.147-45-45-45zm-38.5 0h-50v-25c0-2.757 2.243-5 5-5h40c2.757 0 5 2.243 5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295 437c0 24.853 20.147 45 45 45h127c24.853 0 45-20.147 45-45v-72h-217z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleJobIcon);
export default __webpack_public_path__ + "static/media/singleJobIcon.78613028f3d708b71699cf3239adee7b.svg";
export { ForwardRef as ReactComponent };